import { css } from 'styled-components';

import { theme } from './theme';

// This file exports CSS color variables for 2020 styling
// to make them accessible in a similar way to 2024 styling
export const colorVars = css`
  :root {
    /* Colors from 2024 styling */
    --stile-green-1: ${theme.colors.green1};
    --stile-green-2: ${theme.colors.green2};
    --stile-grey-8: ${theme.colors.grey10};
    --white: ${theme.colors.white1};
  }
`;

export default colorVars;
